import { render, staticRenderFns } from "./RequiredDocument.vue?vue&type=template&id=535c8878"
import script from "./RequiredDocument.vue?vue&type=script&lang=ts"
export * from "./RequiredDocument.vue?vue&type=script&lang=ts"
import style0 from "./RequiredDocument.vue?vue&type=style&index=0&id=535c8878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports